import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'src/redux/store';
import { LedgerCategoriesClient, LedgerCategoryResponse } from 'src/utility/apis/crewPayApiClient';
import axios from 'src/utility/apis/crewPayAxios';
import { handleError } from 'src/utility/utils';

export interface LedgerCategory extends LedgerCategoryResponse { }

export interface State {
    isLoading: boolean;
    error: boolean;
    ledgerCategoryList: LedgerCategory[];
}

const initialState: State = {
    isLoading: false,
    error: false,
    ledgerCategoryList: [],
};

const ledgerCategorySlice = createSlice({
    name: 'ledgerCategory',
    initialState,
    reducers: {
        startLoading: (state) => {
            state.isLoading = true;
        },
        hasError: (state, action) => {
            state.error = action.payload;
            state.isLoading = false;
        },
        getAllLedgerCategorySuccess: (state, action: PayloadAction<LedgerCategory[]>) => {
            state.ledgerCategoryList = action.payload.sort((a, b) => a.ledgerCategorySortOrder - b.ledgerCategorySortOrder);
            state.isLoading = false;
        },
    },
});

// Reducer
export default ledgerCategorySlice.reducer

// Actions
export const {
    startLoading,
    hasError,
    getAllLedgerCategorySuccess,
} = ledgerCategorySlice.actions;

// for useSelector
export const selectLedgerCategory = (state: RootState) => state.ledgerCategory as State;

// ----------------------------------------------------------------------
export function getAllLedgerCategory() {
    return async (dispatch, getState) => {
        try {
            const { ledgerCategoryList } = selectLedgerCategory(getState());
            if (ledgerCategoryList.length === 0) {
                dispatch(ledgerCategorySlice.actions.startLoading());
                const client = new LedgerCategoriesClient(undefined, axios);
                const response = await client.getAll();
                dispatch(ledgerCategorySlice.actions.getAllLedgerCategorySuccess(response));
            }
        } catch (error) {
            dispatch(ledgerCategorySlice.actions.hasError(true));
            handleError(error);
        }
    };
}